import type { ComponentProps } from "react";
import { cn } from "../lib/cn";
import { fieldClass } from "./control-styles";

export function Select({ className, ...props }: ComponentProps<"select">) {
  return <select className={cn(fieldClass, className)} {...props} />;
}
